<template>
  <div>
    <div style="background-color: white;width: 890px;">
      <table width="890" cellspacing="0" cellpadding="0" border="0">
        <tr>
          <td>
            <h1>{{name}}</h1>
          </td>
        </tr>
        <tr>
          <td>
            <span v-for="(item,index) in itemsList" :key="index">
              <el-image :src="item.imageName" :title="'图片'+(index+1)" :name="'图片'+(index+1)" :label="'图片'+(index+1)"
                fit="scale-down" :style="item.size" /><br />
              <span :style="'font-size:16px;'+spansize" v-html="item.showName" v-if="item.isShow"></span><br />
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span v-html="content" class="my-item-span2"></span>
          </td>
        </tr>
        <tr>
          <td>
            <span v-for="(param,index) in paramsList" :key="index">
              <el-image :src="param.imageName" :title="'参数'+(index+1)" :name="'参数'+(index+1)" :label="'参数'+(index+1)"
                fit="scale-down" style="float:left;" /><br />
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  import {
    getItemDesc,
  } from '@/api/item.js'

  export default {
    name: 'ItemDesc',
    data: function() {
      return {
        content: "",
        name: "",
        itemsList: [],
        paramsList: [],
      }
    },
    methods: {

    },
    components: {},
    created() {
      var id = this.$route.query.itemId;
      this.$store.state.myactive = this.$route.query.nid;
      if (Number(id)) {
        getItemDesc('item/getDesc?itemId=' + id, this, "2");
      }
    },
  }
</script>

<style>
  .my-item-span1 {
    font-size: 20px;
    text-align: center;
    color: red;
  }

  .my-item-span2 {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/ItemDesc.vue